import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { TProgramsAudienceProgramSources } from '../types';

type TGetProgramAudienceProgramSourcesProps = {
  idIn?: string[];
  scopeIn?: string;
  mediaType?: string;
  includeIds?: string[];
  name?: string;
};

export const getProgramsAudienceProgramSources = async ({
  idIn,
  scopeIn,
  mediaType,
  includeIds,
  name,
}: TGetProgramAudienceProgramSourcesProps): Promise<TProgramsAudienceProgramSources[]> => {
  const params = {
    ...(idIn && { id__in: idIn.join(',') }),
    ...(scopeIn && { scope_in: scopeIn }),
    ...(mediaType && { media_type__in: mediaType }),
    ...(includeIds && includeIds.length > 0 && { include_ids: includeIds.join(',') }),
    ...(typeof name === 'string' && name.trim() !== '' && { search: name }),
  };

  return mediaManagerClient
    .get('/api/v1/audience_program_sources', { params })
    .then(({ data }) => data);
};
type QueryFnType = typeof getProgramsAudienceProgramSources;

type UseProgramsOptions = {
  idIn?: string[];
  config?: QueryConfig<QueryFnType>;
  scopeIn?: string;
  mediaType?: string;
  includeIds?: string[];
  name?: string;
};

export const useGetProgramsAudienceProgramSources = ({
  config,
  scopeIn,
  mediaType,
  idIn,
  includeIds,
  name,
}: UseProgramsOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['program-classifications', scopeIn, mediaType, idIn, includeIds, name],
    queryFn: () =>
      getProgramsAudienceProgramSources({ scopeIn, mediaType, idIn, includeIds, name }),
  });
};
